module.exports = __webpack_public_path__ + "img/DateTimeRange.1a9f80bb.svg";